import { render, staticRenderFns } from "./VideoJyh.vue?vue&type=template&id=6fe0a64e&scoped=true&"
import script from "./VideoJyh.vue?vue&type=script&lang=ts&"
export * from "./VideoJyh.vue?vue&type=script&lang=ts&"
import style0 from "./VideoJyh.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoJyh.vue?vue&type=style&index=1&id=6fe0a64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe0a64e",
  null
  
)

export default component.exports